import React from 'react';
import PropTypes from 'prop-types';
import {ParallaxLayer, ExpandingBlurb, Video} from '../../';

export default class ControlSection extends React.PureComponent {
    static propTypes = {
        controlsData: PropTypes.object,
        active: PropTypes.bool,
        height: PropTypes.number,
        width: PropTypes.number,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        rebuildDirty: PropTypes.bool
    };

    state = {
        play: false
    };

    parallax = null;
    disabled = false;

    componentWillReceiveProps(nextProps) {
        if (nextProps.active) {
            this.disabled = false;
            if (!this.parallax) {
                this.setupParallax();
            } else if (!(this.props.active && nextProps.active)) {
                this.parallax.enable();
                if (process.env.NODE_ENV !== 'production') {
                    console.debug('parallax enable controls');
                }
            }
        } else if (!this.disabled && this.parallax) {
            this.parallax.disable();
            if (process.env.NODE_ENV !== 'production') {
                console.debug('parallax disable controls');
            }
            this.disabled = true;
        }

        if (!nextProps.active && this.state.play) {
            this.setState({
                play: false
            });
        }

        if (this.props.rebuildDirty !== nextProps.rebuildDirty) {
            this.handleResize();
        }
    }

    handleResize = () => {
        if (!this.parallax) return;

        this.parallax.updateDimensions();
        if (process.env.NODE_ENV !== 'production') {
            console.debug('parallax controls updateDimensions');
        }
    };

    componentDidMount() {
        this.setupParallax();
        if (!this.props.active) {
            this.parallax.disable();
        }
    }

    setupParallax = () => {
        if (this.parallax) return;

        if (process.env.NODE_ENV !== 'production') {
            console.debug('setupParallax controls');
        }

        const scene = document.getElementById('controlScene');

        const scalarX = this.props.mobile ? 4 : 4;
        const scalarY = this.props.mobile ? 2 : 2;

        this.parallax = new Parallax(scene, {
            limitY: 0,
            limitX: 200,
            scalarX,
            scalarY,
            frictionX: 0.4,
            frictionY: 0.05
        });

        //bc it gets intialized disabled it hits a bug in parallex which doesn't start the device orientation listener without this hack
        if (this.props.mobile || this.props.tablet) {
            this.parallax.orientationStatus = 1;
        }
    };

    imagesLoaded = false;

    playPause = () => {
        this.setState({
            play: !this.state.play
        });
    };

    closeVideo = () => {
        this.setState({
            play: false
        });
    };

    render() {
        const {controlsData, active} = this.props;
        const contentStyle = active ? 'content active' : 'content not-visible';

        const videoId = controlsData.videoID || '';

        if (this.props.active) this.imagesLoaded = true;

        return (
            <div id="controlSection" className="section">
                <div id="controlScene" className="parallax-scene gamePlay">
                    <ParallaxLayer depth={0.2} height={this.props.height} width={this.props.width} noPointerEvents={true}>
                        {this.props.active || this.imagesLoaded ?
                            <div className={this.props.mobile || this.props.tablet ? 'bots small' : 'bots'} /> : ''}
                    </ParallaxLayer>
                    <ParallaxLayer depth={0.05} height={this.props.height} width={this.props.width} noPointerEvents={true}>
                        <div className={contentStyle}>
                            <h1>{controlsData.title}</h1>
                        </div>
                    </ParallaxLayer>
                </div>
                <div role="presentation" onClick={this.closeVideo} className={`overlay ${this.state.play ? 'on' : ''}`} />
                <Video
                    video={videoId}
                    active={this.props.active}
                    play={this.state.play}
                    playPauseFunc={this.playPause}
                    poster={false}
                    align="center"
                    backShadow={false}
                    buttonColor="yellow" />
                <ExpandingBlurb
                    htmlText={controlsData.descript}
                    position="bottom"
                    active={this.props.active} />
            </div>
        );
    }
}
